import { useContext, useMemo } from 'react'
import JurisdictionsContext from '../context/JurisdictionsContext'

export default function useRussianJurisdictionDoesApply() {
  const jurisdictions = useContext(JurisdictionsContext)
  // should return true, false, or null
  return useMemo(() => {
    return jurisdictions?.find((x) => x.jurisdiction === 'RUSSIA')?.doesApply ?? null
  }, [jurisdictions])
}
